import React__default from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import { createContext } from '../../utils/context.esm.js';
import { isBrowser } from '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import { useSafeLayoutEffect } from '../../hooks/use-safe-layout-effects.esm.js';
import '../../hooks/use-callback-ref.esm.js';
import '../../hooks/use-clickable.esm.js';
import '../../hooks/use-clipboard.esm.js';
import '../../hooks/use-combobox-dropdown-style.esm.js';
import '../../hooks/use-combobox-style.esm.js';
import '../../hooks/use-controllable.esm.js';
import '../../hooks/use-local-storage.esm.js';
import '../../hooks/use-media.esm.js';
import '../../hooks/use-prefers-dark-mode.esm.js';
import '../../hooks/use-dark-mode.esm.js';
import '../../hooks/use-force-update.esm.js';
import '../../hooks/use-descendant.esm.js';
import '../../hooks/use-id.esm.js';
import '../../hooks/use-previous.esm.js';
import '../../hooks/use-disclosure.esm.js';
import '../../hooks/use-dropdown-style.esm.js';
import '../../hooks/use-latest-ref.esm.js';
import '../../hooks/use-event-listener.esm.js';
import '../../hooks/use-event-listener-v2.esm.js';
import '../../hooks/use-update-effect.esm.js';
import '../../hooks/use-focus-on-hide.esm.js';
import '../../hooks/use-pointer-event.esm.js';
import '../../hooks/use-focus-on-pointerdown.esm.js';
import '../../hooks/use-focus-on-show.esm.js';
import '../../hooks/use-fork-ref.esm.js';
import '../../hooks/use-hints.esm.js';
import '../../hooks/use-input-style.esm.js';
import '../../hooks/use-key-press.esm.js';
import '../../hooks/use-lock-body-scroll.esm.js';
import '../../hooks/use-platform.esm.js';
import '../../hooks/use-shortcut.esm.js';
import ReactDOM from 'react-dom';
import { usePortalManager } from './portal-manager.esm.js';

var _createContext = /*#__PURE__*/createContext({
  strict: false,
  name: 'PortalContext'
}),
    PortalContextProvider = _createContext[0],
    usePortalContext = _createContext[1];

var Portal = function Portal(props) {
  var onMount = props.onMount,
      onUnmount = props.onUnmount,
      children = props.children,
      getContainer = props.getContainer;

  var _React$useState = React__default.useState(function () {
    if (isBrowser) {
      var div = document.createElement('div');
      div.className = 'sajari-portal';
      return div;
    } // for ssr


    return null;
  }),
      portal = _React$useState[0]; // This portal might be nested in another portal.
  // Let's read from the portal context to check this.


  var parentPortal = usePortalContext(); // If there's a PortalManager rendered, let's read from it.
  // We use the portal manager to manage multiple portals

  var manager = usePortalManager();
  var append = React__default.useCallback(function (container) {
    // if user specified a mount node, do nothing.
    if (!portal || !container) return; // else, simply append component to the portal node

    container.appendChild(portal);
  }, [portal]);
  useSafeLayoutEffect(function () {
    var _ref, _ref2;

    // get the custom container from the container prop
    var customContainer = getContainer == null ? void 0 : getContainer(); // We need to know where to mount this portal, we have 4 options:
    // - If a mountRef is specified, we'll use that as the container
    // - If portal is nested, use the parent portal node as container.
    // - If it's not nested, use the manager's node as container
    // - else use document.body as containers

    var container = (_ref = (_ref2 = customContainer != null ? customContainer : parentPortal) != null ? _ref2 : manager == null ? void 0 : manager.node) != null ? _ref : document.body; // Append portal node to the computed container

    append(container);
    onMount == null ? void 0 : onMount();
    return function () {
      onUnmount == null ? void 0 : onUnmount();
      if (!portal) return;

      if (container == null ? void 0 : container.contains(portal)) {
        container == null ? void 0 : container.removeChild(portal);
      }
    };
  }, [getContainer, portal, parentPortal, onMount, onUnmount, manager == null ? void 0 : manager.node, append]);
  var innerChildren = (manager == null ? void 0 : manager.zIndex) ? React__default.createElement("div", {
    className: "sajari-portal-zIndex",
    style: {
      position: 'absolute',
      zIndex: manager.zIndex,
      width: '100%'
    }
  }, children) : children;

  if (!portal) {
    return React__default.createElement(React__default.Fragment, null, innerChildren);
  }

  return ReactDOM.createPortal(React__default.createElement(PortalContextProvider, {
    value: portal
  }, innerChildren), portal);
};

if (__DEV__) {
  Portal.displayName = 'Portal';
}

export default Portal;
//# sourceMappingURL=index.esm.js.map
